import React, {useState} from "react";
import {Grid, Paper} from "@material-ui/core";
import {useHistory, withRouter} from "react-router-dom";

import useStyles from "../../../components/useStyles";
import backgroundTwo from "../../../images/INQBAY_HP_2.png";
import next from "../../../images/next.png";


const BaseQuiz = (
    {
        questions,
        images,
        match,
    }
) => {
    /* Hooks */
    const classes = useStyles();
    const [answersSent, setAnswersSent] = useState(false);
    const [answers, setAnswers] = useState([]);
    const history = useHistory();

    /* State */
    const pages = [
        [
            questions[0],
            questions[1],
        ],
        [
            questions[2],
            questions[3],
        ],
    ];
    const currentPage = match.params.page - 1;
    const activePage = pages[currentPage];
    const isLastPage = currentPage === pages.length - 1;

    /* Helper functions */
    const getSendText = () => {
        if (answersSent) {
            return isLastPage ? 'Jak to tedy je?' : 'Další kvíz';
        }

        return <img src={next}/>;
    }

    const submitQuiz = () => {

        for (const key in activePage)
            if (!(key in answers))
                return alert('Vyberte u každé otázky jednu odpověď.');

        if (answersSent) {
            if (isLastPage) {
                return history.push('../pdf');
            }

            setAnswersSent(false);
            setAnswers([]);
            history.push(`${currentPage + 2}`)
            return;
        }

        setAnswersSent(true);
    }

    const isAnswerSelected = (q, a) => {
        if (!(q in answers))
            return false;

        return answers[q] === a;
    };

    const getAnswerClass = (q, a) => {

        if (isAnswerSelected(q, a)) {
            if (answersSent) {
                return activePage[q].answers[a].correct ? 'btn btn--primary--invert--small--correct' : 'btn btn--primary--invert--small--incorrect';
            }

            return 'btn btn--primary--invert--small--select';
        }

        return 'btn btn--primary--invert--small';
    };

    const setAnswerSelected = (q, a) => {
        if (answersSent)
            return;

        const newAnswers = [...answers];
        newAnswers[q] = a;
        setAnswers(newAnswers);
    };

    /* Template */
    return (
        <Grid className={classes.paper_center} container spacing={0} style={{
            backgroundImage: "url(" + backgroundTwo + ")",
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
        }}>
            <Grid className={classes.paper_center} item xs={12} md={6}>
                <Grid className={classes.paper_center}>
                    <div className={'textSize1'}>
                        <br/>
                        VYZKOUŠEJTE SI<br/>
                        (v textu a podcastu najdete odpovědi)<br/>
                        {
                            activePage.map((question, questionIndex) => <>
                                <Paper className={classes.whitePaper}>
                                    <Paper className={classes.groupPaper}>
                                        <div className={classes.com}>
                                            <h4>{question.header}</h4>
                                        </div>
                                    </Paper>
                                </Paper>
                                <Paper className={classes.whitePaper}>
                                    <Paper className={classes.groupPaper}>
                                        <div className={classes.com}>
                                            {
                                                question.answers.map((answer, answerIndex) => <>
                                                    <button
                                                        className={getAnswerClass(questionIndex, answerIndex)}
                                                        onClick={() => setAnswerSelected(questionIndex, answerIndex)}>
                                                        <Grid className={classes.paper}>
                                                            <a className={classes.blackText}>
                                                                {String.fromCharCode('A'.charCodeAt(0) + answerIndex)}
                                                            </a>
                                                        </Grid>
                                                    </button>
                                                    {answer.content}
                                                    <br/>
                                                    <br/>
                                                </>)
                                            }
                                        </div>
                                    </Paper>
                                </Paper>
                            </>)
                        }
                    </div>
                    <br/>
                </Grid>
            </Grid>
            <Grid className={classes.paper_center} item xs={12} md={6}>
                <Grid>
                    <img src={images[currentPage] || null} className={classes.mainIMG}/>
                </Grid>
            </Grid>
            <Grid className={classes.paper_center} item xs={12} md={12}>
                <Grid>
                    <button className={"btn btn--primary--solid--long2"} onClick={submitQuiz}>
                        <Grid className={classes.paper}>
                            <a className={classes.blackText}>
                                {getSendText()}
                            </a>
                        </Grid>
                    </button>
                </Grid>
            </Grid>
        </Grid>
    );
};
export default withRouter(BaseQuiz);
